module.exports = __webpack_public_path__ + "static/media/broadband_2.0df38dbc.svg";